import {combineReducers} from 'redux';
import {createReducer} from 'util/redux';
import {ThemeOptions} from '@mui/material';
import {globalThemeChangedAction} from 'module/Theme/action/ThemeAction';

const global = createReducer<ThemeOptions | null>(null, builder => builder
	.addCase(globalThemeChangedAction, (state, {payload}) => payload),
);
export const ThemeReducerNS = {Theme: combineReducers({global})}
export type ThemeStateType = { Theme: ReturnType<typeof ThemeReducerNS.Theme> }